<template>
    <div v-if="openModal">
        <form action="#" @submit.prevent="sendToServer">
            <div ></div>
            <div class="modal-co">
                <div class="header-modal content-modal-folder">
                    <h4 class="modal-h4">{{ data.title }}</h4>
                    <span class="path-line" @click="backFolder()"> <i data-v-9c16672c="" aria-hidden="true" class="fa fa-arrow-left"> </i> home{{ newPath }}</span>
                </div>
                <div class="content-modal content-modal-folder ">

                    <div class="window-folder-list">
                        <ul class="window-folder-list-ul">
                            <li  v-for="(item, index) in items" :key="item.id"  @click="clickImage(item)">
                                <div v-if="item.type == 'folder'">
                                    <svg class="folder-modal" id="FolderRepresentation" data-name="FolderRepresentation"
                                    xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 64 64">
                                    <path class="st0" d="M6,59c-2.8,0-5-2.2-5-5V10c0-2.8,2.2-5,5-5h20.2c1.1,0,2.1,0.4,2.8,1.2l6.2,6.2c0.4,0.4,0.9,0.6,1.4,0.6H58
                                    c2.8,0,5,2.2,5,5v36c0,2.8-2.2,5-5,5H6z"></path>
                                    <path class="st1" d="M58,12H36.7c-0.3,0-0.5-0.1-0.7-0.3l-6.2-6.2c-1-1-2.2-1.5-3.5-1.5H6c-3.3,0-6,2.7-6,6v44c0,3.3,2.7,6,6,6h52
                                    c3.3,0,6-2.7,6-6V18C64,14.7,61.3,12,58,12z M62,54c0,2.2-1.8,4-4,4H6c-2.2,0-4-1.8-4-4V14h56c2.2,0,4,1.8,4,4V54z"></path>
                                </svg>
                                <span>{{ item.title }}</span>
                            </div>
                            <div class="gr-unactive" v-else>

                                <img :src="item.icon" alt="title">
                                <span>{{ item.title }}</span>
                            </div>

                        </li>




                    </ul>
                </div>

            </div>
            <div class="footer-modal text-right">
                <span class="model-cancel" @click="cancelCreateFolderModal">Cancel</span>
                <button  class="success-button active-success-button" type="submit" >Готово</button>

            </div>
        </div>
    </form>
</div>
</template>

<script>

    import axios from 'axios'

    export default {
        name: 'create-folder',
        data(){
            return {
                data: {
                    title: 'Прехвърляне'
                },
                newPath: '',
                idForItem: 4,
                openModal: false,
                path: '',
                items: [],
                historyFolder: '',
                selected: [],
                act: '',
                mass: false,
            }
        },

        created() {

            this.getItems()

            eventBus.$on('openModalMoveFolder', (data) => {

                this.openModal = data.openModal
                this.path = data.path
                this.selected = data.item
                this.act = data.act
                this.mass = data.mass

                if(data.act == 'move') {

                } else {

                    this.data.title = 'Копиране'

                }
            })
        },

        beforeDestroy() {
           eventBus.$off('openModalMoveFolder')
       },

       methods: {
        submitButton() {
         
            this.sendToServer()
            
            this.openModal = false
        },
        sendToServer() {

            if(this.mass) {
                var url = this.$store.getters.getMainDomainName+'system/files/mass/'+this.act
            } else {
                var url = this.$store.getters.getMainDomainName+'system/files/'+this.act
            }

            axios.post(url, {
                newPath: this.newPath,
                checked: this.selected,
            })

            .then(response => {
                console.log(response.data)
                // this.data.title = 'Create folder'

                if(this.act != 'copied' && !this.mass) {
                    this.$emit('finishedMoveFile', response.data)

                } else if(this.act != 'copied' && this.mass) {
                    this.$emit('finishedMoveFileMass', response.data)

                }

                this.clearComponent()


            })
            .catch(error => {})

            this.newTitle = '',
            this.idForItem++
        },



        clickImage(item) {

            if(item.type == 'folder'){ 
                this.newPath = item.path + '/' + item.title 

                if(item.type == 'folder') {

                    var folder = item.path + '/' + item.title

                    this.historyFolder = item.path
                    this.activePath = folder

                    this.openFolder(folder)
                }


            }

        },
        openFolder(folder) {
            axios.post(this.$store.getters.getMainDomainName+'open-folder', {
                folder: folder,
            })
            .then(response => {
                this.items = response.data
                console.log(this.items)

            })
        },
        backFolder() {

            this.newPath = this.historyFolder

            this.openFolder(this.historyFolder)

            if(this.historyFolder == '/felis' || this.historyFolder == '' ) {
                this.historyFolder = ''
            } else {
              var lastIndex =  this.historyFolder.lastIndexOf("/");

              this.historyFolder =  this.historyFolder.substring(0, lastIndex);
          }

      },
      
      cancelCreateFolderModal() {
         this.openModal = false
     },
     clearComponent() {

        this.openModal = false
        this.newPath = ''
        this.path = ''
        this.itemEdit = false
        this.items = []
        this.historyFolder = ''
        this.selected = []
        this.act = ''
    },
    getItems() {

        axios.get(this.$store.getters.getMainDomainName+'system/files')
        .then(response => {
            this.items =  response.data
            this.loading = false
            console.log(this.items)

        })
        .catch(error => {})
    }
},

}

</script>

<style scoped src="../../assets/css/modals/folder.css"></style>




// WEBPACK FOOTER //
// src/components/app_modules/ModalMoveFolder.vue